import { FC, useState } from "react";
import { DirectionalHint, initializeIcons, Stack, Text, TooltipHost } from "@fluentui/react";
import { colorPallete } from "../../../assets/color";
import "../ProjectDataButtonStack/index.css";

interface FunctionalityButtonProps {
  buttonText: string;
  color: string;
  onClickFunction: () => void;
  flex: string;
  icon: string;
  borderColor: string;
  hoverColor?: string;
  tooltipValue?: string;
}

const styles = {
  headerStyle: {
    fontSize: "1.525rem",
    color: colorPallete.black1,
    fontFamily: "Poppins",
    fontWeight: "500",
  },

  headerText: {
    fontSize: "1rem",
    color: colorPallete.grey5,
    fontFamily: "Poppins",
  },
};

initializeIcons();
export const ProjectDataButton: FC<FunctionalityButtonProps> = (props) => {
  const [hovered, setHovered] = useState(false);
  return (
    <TooltipHost
      content={props.tooltipValue}
      directionalHint={DirectionalHint.bottomCenter}
      calloutProps={{
        styles: {
          beak: { 
            background: props.borderColor,
            borderRadius: "2px",
          },
          beakCurtain: { 
            background: props.borderColor,
            borderRadius: "8px"
          },
          root: { 
            borderRadius: "8px",
            top: "-10px",
          },
          calloutMain: { 
            background: props.borderColor, 
            borderRadius: "8px",
            padding: "2px 5px"
          },
        },
      }}
      tooltipProps={{
        styles: {
          content: { color: "white", fontFamily: "Poppins", fontSize: "14px", fontWeight:"600" },
        },
      }}
      styles={{ root: { flex: props.flex, display: "flex" } }}
    >
      <Stack
        style={{
          backgroundColor: hovered && props.hoverColor ? props.hoverColor : props.color,
          alignItems: "flex-start",
          flex: props.flex,
          display: "flex",
          margin: "0% 0.8%",
          borderRadius: "0.4rem",
          justifyContent: "center",
          height: 106,
          boxShadow: "rgba(0, 0, 0, 0.26) 0px 4px 20px 0px",
          alignSelf: "center",
          border: `2px solid ${props.borderColor}`,
          transition: "background-color 0.2s ease-in-out",
          cursor: "pointer",
          width: "100%",
        }}
        className="Button"
        onClick={props.onClickFunction}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Stack style={{ width: "98%" }}>
          <Text style={styles.headerText}>
            {props.buttonText.split("-")[0] + "\n"}
          </Text>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: 5,
            }}
          >
            <div>
              <Text style={{ ...styles.headerStyle, color: props.borderColor, fontWeight: 600 }}>
                {props.buttonText.split("-")[1]}
              </Text>
            </div>
            <div style={{ alignItems: "flex-end", paddingRight: 5 }}>
              <Text style={{ ...styles.headerStyle, color: props.borderColor, fontWeight: 600 }}>
                {props.buttonText.split("-")[2]}
              </Text>
            </div>
          </div>
        </Stack>
      </Stack>
    </TooltipHost>
  );
};
